export { default } from './StarRating';
